// Constants
const MAIN_LIST_SIZE = 5;

// Error codes and messages
const ErrorCodes = {
	OK: 1000,
	SUCCESS: 1001,
	NONE: 1002,
	SYSTEM_UNKNOWN_ERROR: 0,
	BINDING_ERROR: 1,
	EMPTY_TOKEN: 10,
	INVALID_TOKEN: 11,
	EMPTY_APP_VERSION: 21,
	UPGRADE_APP_VERSION: 22,
	INVALID_USER_AGENT: 23,
	INVALID_APP_VERSION: 24,
	FILE_NOT_FOUND: 91,
	BOARD_NOT_FOUND: 92,
	DATA_NOT_FOUND: 93,
	USERID_DUPLICATE: 105,
	EMAIL_DUPLICATE: 106,
	FAIL_CONVERT_BASE64: 107,
	FAIL_SEND_MAIL: 108,
	FAIL_SEND_SMS: 109,
	GROUPNM_DUPLICATE: 110,
	ADDGROUP_NULLDATA: 111,
	LOGIN_FAIL: 112,
	EMPTY_USER: 113,
	TOO_MUCH_REQ: 114,
	WRONG_OTP: 115,
	NO_VALID_DATA: 116,
	NO_VALID_PARAM: 117,
	INVALID_PWD: 118,
	EMPTY_ROLE: 119,
	INVALID_PATH_PARAM: 120,
	INSUFFICIENT_PARAM: 501,
	NOT_FOUND_USER: 502,
	WITHDRAWN_MEMBER: 503,
	WRONG_PASSWD: 504,
	AUTH_TIMEOUT: 505,
	AUTH_FAIL: 506,
	ALREADY_EXIST_MEMBER: 507,
	DUPLICATE_LOGIN: 508,
	NO_LOGIN_INFORMATION: 509,
	WRONG_LOGIN_TYPE: 510,
	FAIL_ADD_INFO: 511,
	FAIL_LIMIT_PASSWD: 512,
	DISABLE_FIND_PASSWD_SNS: 513,
	ACCOUNT_EMAIL: 514,
	ACCOUNT_SNS: 515,
	DISABLE_LOGIN_ACCOUNT: 516,
	LOGIN_ERROR: 527,
	FAIL_SEND_TMP_PASSWD: 518,
	FAIL_JOIN_MEMBER: 519,
	FAIL_SEND_AUTHCODE: 520,
	FAIL_UPDATE_AUTH: 521,
	FAIL_UPDATE_PRIVATE: 523,
	FAIL_UPDATE_PASSWD: 524,
	FAIL_SET_BMI: 525,
	FAIL_SET_SLEEP: 526,
	FAIL_SET_SMARTALM: 527,
	FAIL_SET_SLEEP_RPT: 528,
	FAIL_SET_UNLOCK_WAIT: 529,
	FAIL_WAKEUP_ALM: 530,
	FAIL_WITHDRAWN: 531,
	FAIL_SET_BGSOUND: 532,
	FAIL_SET_LANG: 533,
	FAIL_SRCH_CONTENT: 544,
	FAIL_UPLOAD_PLAYINFO: 545,
	FAIL_SAVE_GRADING: 546,
	FAIL_SAVE_ACTIVE_INFO: 547,
	FAIL_SAVE_FAVOR: 548,
	FAIL_DEL_FAVOR: 549,
	FAIL_SRCH_DAILY_STAT: 550,
	FAIL_SRCH_DAILY_ACTIVE: 551,
	FAIL_SRCH_DAILY_CONTENTS: 552,
	FAIL_SRCH_WEEKLY_STAT: 553,
	FAIL_SRCH_MONTHLY_STAT: 554,
	FAIL_SRCH_TOT_STAT: 555,
	FAIL_SRCH_COMPARISON_GRP_STAT: 556,
	FAIL_SRCH_COMPARISON_CONTENTS: 557,
	FAIL_SRCH_BGMUSIC: 558,
	FAIL_SET_LIFEINFO: 559,
	LOGOUT_PROC_ERROR: 560,
	FAIL_SAVE_CUSTOMER_SUGGEST: 561,
	FAIL_PROC_END_SLEEP: 562,
	FAIL_UPLOAD_USEINFO: 563,
	ALREADY_EXIST_TODAY_STAT: 564,
	FAIL_CHK_PASSWD: 565,
	FAIL_SRCH_SETINFO: 566,
	FAIL_READ_S3: 567,
	DISABLE_CHANGE_SAME_PASSWD: 568,
	OVER_30DAYS_SLEEPYMD: 569,
	LOG_SIZE_ZERO: 570,
	MISMATCH_T_FROM_SLEEPYMD: 571,
	FAIL_CHK_EXISTS_DAILY_STAT: 572,
	DISABLE_SAME_PASSWD_EMAIL: 573,
	DISABLE_SAME_PASSWD_PHONE: 574,
	DUPLICATE_DATA_ERROR: 575,
	SQL_GRAMMER_ERROR: 576,
	DATA_INTEGRITY_VIOLATION_ERROR: 577,
	DB_ERROR: 578,
	NO_EXIST_SET_CONTENT: 579,
	ALREADY_EXIST_REPLY: 580,
	NO_EXIST_SLEEP_DATA: 581,
	NO_EXIST_REDIS_DATA: 582,
	FAVOR_MUST_NOT_OVER_30: 583,
	NO_VALID_DATE: 600,
	FILE_UPLOAD_FAILED: 601,
	DISABLE_CHANGE_SAME_PHONE: 602,
	TIME_PARADOX: 603,
	NO_EXIST_STUDY_DATA: 604,
	ALREADY_SHARED_ACCOUNT: 701,
	NOW_LOGINED_ACCOUNT: 702,
	ACCOUNT_ALREADY_EXIST: 703,
	NO_EXIST_TOKEN: 800,
	INCORRECT_HTTP_METHOD: 801,
	EXPIRED_TOKEN: 802,
	CONTENT_TYPE_MISMATCH: 803,
	JSON_SYNTAX_ERROR: 804,
	NO_EXIST_CONTENT_TYPE: 805,
	NO_EXIST_SERVICE_CODE: 806,
	NO_EXIST_APPLICATION_VERSION: 807,
	NO_EXIST_USER_AGENT_SIMULATION: 808,
	NO_EXIST_API: 809,
	INCORRECT_PASSWORD: 810,
	SIGN_ERROR_TOKEN: 811,
	NO_EXIST_OS_TYPE: 812,
	NO_EXIST_LANGUAGE_TYPE: 813,
	INVALID_HEADER_ACCEPT_SERVICE: 814,
	INVALID_HEADER_DEVICE_INFO: 815,
	INVALID_HEADER_WEARABLE_INFO: 816,
	INVALID_HEADER_PACKAGE_INFO: 817,
	INVALID_HEADER_LOCALE_INFO: 818,
	ALREADY_EXIST_NICKNAME: 819,
	FAIL_UPLOAD_S3: 820,
	NO_EXIST_ACCOUNT: 821,
	TIME_ZONE_DUPLICATE_DATA: 900,
};

// Error messages mapping
const errorMessages = {
	[ErrorCodes.SYSTEM_UNKNOWN_ERROR]: "알수없는 에러가 발생하였습니다.",
	[ErrorCodes.BINDING_ERROR]: "Binding 에러",
	[ErrorCodes.EMPTY_TOKEN]: "토큰(로그인정보)이 없습니다.",
	[ErrorCodes.INVALID_TOKEN]: "토큰(로그인정보)이 유효하지 않습니다.",
	[ErrorCodes.EMPTY_APP_VERSION]: "Application 버전 정보가 없습니다.",
	[ErrorCodes.UPGRADE_APP_VERSION]: "Application 버전 업그레이드가 필요합니다.",
	[ErrorCodes.INVALID_USER_AGENT]: "User-Agent 정보가 올바르지 않습니다.",
	[ErrorCodes.INVALID_APP_VERSION]: "Package 정보가 올바르지 않습니다.",
	[ErrorCodes.FILE_NOT_FOUND]: "파일이 존재하지 않습니다.",
	[ErrorCodes.BOARD_NOT_FOUND]: "게시판이 존재하지 않습니다.",
	[ErrorCodes.DATA_NOT_FOUND]: "데이터가 존재하지 않습니다.",
	[ErrorCodes.USERID_DUPLICATE]: "중복된 아이디가 있습니다.",
	[ErrorCodes.EMAIL_DUPLICATE]: "중복된 이메일이 있습니다.",
	[ErrorCodes.FAIL_CONVERT_BASE64]: "파일 변환에 실패하였습니다.",
	[ErrorCodes.FAIL_SEND_MAIL]: "이메일 발송에 실패하였습니다.",
	[ErrorCodes.FAIL_SEND_SMS]: "SMS 발송에 실패하였습니다.",
	[ErrorCodes.GROUPNM_DUPLICATE]: "중복된 그룹명이 있습니다.",
	[ErrorCodes.ADDGROUP_NULLDATA]: "그룹생성시 빈 입력란이 있습니다.",
	[ErrorCodes.LOGIN_FAIL]: "로그인이 실패하였습니다.",
	[ErrorCodes.EMPTY_USER]: "입력하신 정보와 일치하는 회원정보가 없습니다.다시 확인하여 주십시오.",
	[ErrorCodes.TOO_MUCH_REQ]: "잠시후에 다시 시도해주세요.",
	[ErrorCodes.WRONG_OTP]: "인증번호가 올바르지 않습니다.",
	[ErrorCodes.NO_VALID_DATA]: "유효하지 않은 데이터입니다.",
	[ErrorCodes.NO_VALID_PARAM]: "유효하지 않은 파라미터입니다.",
	[ErrorCodes.INVALID_PWD]: "유효한 패스워드가 아닙니다.",
	[ErrorCodes.EMPTY_ROLE]: "권한이 충분하지 않습니다.",
	[ErrorCodes.INVALID_PATH_PARAM]: "유효하지 않은 경로 파라미터입니다.",
	[ErrorCodes.INSUFFICIENT_PARAM]: "필수 파라미터가 부족합니다.",
	[ErrorCodes.NOT_FOUND_USER]: "사용자를 찾을 수 없습니다.",
	[ErrorCodes.WITHDRAWN_MEMBER]: "탈퇴한 회원입니다.",
	[ErrorCodes.WRONG_PASSWD]: "잘못된 비밀번호입니다.",
	[ErrorCodes.AUTH_TIMEOUT]: "인증 시간이 초과되었습니다.",
	[ErrorCodes.AUTH_FAIL]: "인증에 실패하였습니다.",
	[ErrorCodes.ALREADY_EXIST_MEMBER]: "이미 존재하는 회원입니다.",
	[ErrorCodes.DUPLICATE_LOGIN]: "중복 로그인입니다.",
	[ErrorCodes.NO_LOGIN_INFORMATION]: "로그인 정보가 없습니다.",
	[ErrorCodes.WRONG_LOGIN_TYPE]: "잘못된 로그인 유형입니다.",
	[ErrorCodes.FAIL_ADD_INFO]: "정보 추가에 실패하였습니다.",
	[ErrorCodes.FAIL_LIMIT_PASSWD]: "비밀번호 제한에 실패하였습니다.",
	[ErrorCodes.DISABLE_FIND_PASSWD_SNS]: "SNS 비밀번호 찾기가 비활성화되었습니다.",
	[ErrorCodes.ACCOUNT_EMAIL]: "이메일 계정입니다.",
	[ErrorCodes.ACCOUNT_SNS]: "SNS 계정입니다.",
	[ErrorCodes.DISABLE_LOGIN_ACCOUNT]: "로그인이 비활성화된 계정입니다.",
	[ErrorCodes.LOGIN_ERROR]: "로그인 오류입니다.",
	[ErrorCodes.FAIL_SEND_TMP_PASSWD]: "임시 비밀번호 전송에 실패하였습니다.",
	[ErrorCodes.FAIL_JOIN_MEMBER]: "회원 가입에 실패하였습니다.",
	[ErrorCodes.FAIL_SEND_AUTHCODE]: "인증 코드 전송에 실패하였습니다.",
	[ErrorCodes.FAIL_UPDATE_AUTH]: "인증 정보 업데이트에 실패하였습니다.",
	[ErrorCodes.FAIL_UPDATE_PRIVATE]: "개인 정보 업데이트에 실패하였습니다.",
	[ErrorCodes.FAIL_UPDATE_PASSWD]: "비밀번호 업데이트에 실패하였습니다.",
	[ErrorCodes.FAIL_SET_BMI]: "BMI 설정에 실패하였습니다.",
	[ErrorCodes.FAIL_SET_SLEEP]: "수면 설정에 실패하였습니다.",
	[ErrorCodes.FAIL_SET_SMARTALM]: "스마트 알람 설정에 실패하였습니다.",
	[ErrorCodes.FAIL_SET_SLEEP_RPT]: "수면 보고서 설정에 실패하였습니다.",
	[ErrorCodes.FAIL_SET_UNLOCK_WAIT]: "잠금 해제 대기 설정에 실패하였습니다.",
	[ErrorCodes.FAIL_WAKEUP_ALM]: "기상 알람 시간 설정 실패",
	[ErrorCodes.FAIL_WITHDRAWN]: "회원 탈퇴에 실패하였습니다.",
	[ErrorCodes.FAIL_SET_BGSOUND]: "배경음 설정에 실패하였습니다.",
	[ErrorCodes.FAIL_SET_LANG]: "언어 설정에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_CONTENT]: "콘텐츠 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_UPLOAD_PLAYINFO]: "재생 정보 업로드에 실패하였습니다.",
	[ErrorCodes.FAIL_SAVE_GRADING]: "등급 저장에 실패하였습니다.",
	[ErrorCodes.FAIL_SAVE_ACTIVE_INFO]: "활동 정보 저장에 실패하였습니다.",
	[ErrorCodes.FAIL_SAVE_FAVOR]: "즐겨찾기 저장에 실패하였습니다.",
	[ErrorCodes.FAIL_DEL_FAVOR]: "즐겨찾기 삭제에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_DAILY_STAT]: "일일 통계 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_DAILY_ACTIVE]: "일일 활동 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_DAILY_CONTENTS]: "일일 콘텐츠 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_WEEKLY_STAT]: "주간 통계 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_MONTHLY_STAT]: "월간 통계 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_TOT_STAT]: "전체 통계 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_COMPARISON_GRP_STAT]: "그룹 비교 통계 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_COMPARISON_CONTENTS]: "비교 콘텐츠 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_BGMUSIC]: "배경음악 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_SET_LIFEINFO]: "생활 정보 설정에 실패하였습니다.",
	[ErrorCodes.LOGOUT_PROC_ERROR]: "로그아웃 처리 중 오류가 발생하였습니다.",
	[ErrorCodes.FAIL_SAVE_CUSTOMER_SUGGEST]: "고객 제안 저장에 실패하였습니다.",
	[ErrorCodes.FAIL_PROC_END_SLEEP]: "수면 종료 처리에 실패하였습니다.",
	[ErrorCodes.FAIL_UPLOAD_USEINFO]: "사용 정보 업로드에 실패하였습니다.",
	[ErrorCodes.ALREADY_EXIST_TODAY_STAT]: "오늘의 통계가 이미 존재합니다.",
	[ErrorCodes.FAIL_CHK_PASSWD]: "비밀번호 확인에 실패하였습니다.",
	[ErrorCodes.FAIL_SRCH_SETINFO]: "설정 정보 검색에 실패하였습니다.",
	[ErrorCodes.FAIL_READ_S3]: "S3 읽기에 실패하였습니다.",
	[ErrorCodes.DISABLE_CHANGE_SAME_PASSWD]: "동일한 비밀번호로 변경할 수 없습니다.",
	[ErrorCodes.OVER_30DAYS_SLEEPYMD]: "수면 날짜가 30일을 초과하였습니다.",
	[ErrorCodes.LOG_SIZE_ZERO]: "로그 크기가 0입니다.",
	[ErrorCodes.MISMATCH_T_FROM_SLEEPYMD]: "수면 날짜와 시간이 일치하지 않습니다.",
	[ErrorCodes.FAIL_CHK_EXISTS_DAILY_STAT]: "일일 통계 존재 여부 확인에 실패하였습니다.",
	[ErrorCodes.DISABLE_SAME_PASSWD_EMAIL]: "이메일과 동일한 비밀번호는 사용할 수 없습니다.",
	[ErrorCodes.DISABLE_SAME_PASSWD_PHONE]: "전화번호와 동일한 비밀번호는 사용할 수 없습니다.",
	[ErrorCodes.DUPLICATE_DATA_ERROR]: "중복된 데이터 오류입니다.",
	[ErrorCodes.SQL_GRAMMER_ERROR]: "SQL 문법 오류입니다.",
	[ErrorCodes.DATA_INTEGRITY_VIOLATION_ERROR]: "데이터 무결성 위반 오류입니다.",
	[ErrorCodes.DB_ERROR]: "데이터베이스 오류입니다.",
	[ErrorCodes.NO_EXIST_SET_CONTENT]: "설정된 콘텐츠가 존재하지 않습니다.",
	[ErrorCodes.ALREADY_EXIST_REPLY]: "이미 답변이 존재합니다.",
	[ErrorCodes.NO_EXIST_SLEEP_DATA]: "수면 데이터가 존재하지 않습니다.",
	[ErrorCodes.NO_EXIST_REDIS_DATA]: "Redis 데이터가 존재하지 않습니다.",
	[ErrorCodes.FAVOR_MUST_NOT_OVER_30]: "즐겨찾기는 30개를 초과할 수 없습니다.",
	[ErrorCodes.NO_VALID_DATE]: "유효하지 않은 날짜입니다.",
	[ErrorCodes.FILE_UPLOAD_FAILED]: "파일 업로드에 실패하였습니다.",
	[ErrorCodes.DISABLE_CHANGE_SAME_PHONE]: "동일한 전화번호로 변경할 수 없습니다.",
	[ErrorCodes.TIME_PARADOX]: "시간 역설 오류입니다.",
	[ErrorCodes.NO_EXIST_STUDY_DATA]: "학습 데이터가 존재하지 않습니다.",
	[ErrorCodes.ALREADY_SHARED_ACCOUNT]: "이미 공유된 계정입니다.",
	[ErrorCodes.NOW_LOGINED_ACCOUNT]: "현재 로그인된 계정입니다.",
	[ErrorCodes.ACCOUNT_ALREADY_EXIST]: "계정이 이미 존재합니다.",
	[ErrorCodes.NO_EXIST_TOKEN]: "인증 토큰이 없습니다.",
	[ErrorCodes.INCORRECT_HTTP_METHOD]: "요청타입이 맞지 않습니다.",
	[ErrorCodes.EXPIRED_TOKEN]: "만료된 토큰 입니다.",
	[ErrorCodes.CONTENT_TYPE_MISMATCH]: "컨텐츠 타입이 맞지 않습니다.",
	[ErrorCodes.JSON_SYNTAX_ERROR]: "JSON 구문 오류.",
	[ErrorCodes.NO_EXIST_CONTENT_TYPE]: "Header Content-Type 이 존재하지 않습니다.",
	[ErrorCodes.NO_EXIST_SERVICE_CODE]: "Header Service-Code 가 존재하지 않습니다.",
	[ErrorCodes.NO_EXIST_APPLICATION_VERSION]: "Header Application-Version이 존재하지 않습니다.",
	[ErrorCodes.NO_EXIST_USER_AGENT_SIMULATION]: "Header User-Agent가 존재하지 않습니다.",
	[ErrorCodes.NO_EXIST_API]: "정의되지 않은 API",
	[ErrorCodes.INCORRECT_PASSWORD]: "비밀번호가 틀렸습니다.",
	[ErrorCodes.SIGN_ERROR_TOKEN]: "토큰 서명 에러",
	[ErrorCodes.NO_EXIST_OS_TYPE]: "OS type 이 존재하지 않습니다.",
	[ErrorCodes.NO_EXIST_LANGUAGE_TYPE]: "언어 설정 데이터가 존재하지 않습니다.",
	[ErrorCodes.INVALID_HEADER_ACCEPT_SERVICE]: "Service Name Header 데이터가 존재하지 않습니다.",
	[ErrorCodes.INVALID_HEADER_DEVICE_INFO]: "Device Info Header 데이터가 존재하지 않습니다.",
	[ErrorCodes.INVALID_HEADER_WEARABLE_INFO]: "Wearable Info Header 데이터가 존재하지 않습니다.",
	[ErrorCodes.INVALID_HEADER_PACKAGE_INFO]: "Package Info Header 데이터가 존재하지 않습니다.",
	[ErrorCodes.INVALID_HEADER_LOCALE_INFO]: "Locale Info Header 데이터가 존재하지 않습니다.",
	[ErrorCodes.ALREADY_EXIST_NICKNAME]: "이미 존재하는 닉네임 입니다.",
	[ErrorCodes.FAIL_UPLOAD_S3]: "S3파일 업로드 전송 실패",
	[ErrorCodes.NO_EXIST_ACCOUNT]: "계정이 존재하지 않습니다",
	[ErrorCodes.TIME_ZONE_DUPLICATE_DATA]: "시간대 차이로 인해 수면 기록이 중복되었습니다. 중복된 데이터는 자동 삭제됩니다.",
};

// Get error message
function getErrorMessage(code) {
	return errorMessages[code] || "알 수 없는 에러";
}

// Export for module usage
module.exports = {
	ErrorCodes,
	getErrorMessage,
	MAIN_LIST_SIZE,
};
